export interface ProjectLocalConfig {
  isGit: boolean;
  disabledPages?: string[];
}

const defaultConfig: ProjectLocalConfig = {
  isGit: true,
  disabledPages: [],
};

export function getProjectLocalConfig(project: string): ProjectLocalConfig {
  return projectsLocalConfig[project];
}

function extendDefaultConfig(
  config: Partial<ProjectLocalConfig> = {},
): ProjectLocalConfig {
  return {
    ...defaultConfig,
    ...config,
  };
}

const projectsLocalConfig: Record<string, ProjectLocalConfig> = {
  demo: extendDefaultConfig({
    disabledPages: [],
  }),
};
export type ProjectIdentifier = keyof typeof projectsLocalConfig;
